export default __webpack_public_path__ + "static/media/mouse-body.c1a8dde2.svg";